import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
// import Test from '@/views/Test.vue'
import About from '@/views/About.vue'
import Impressum from '@/views/Impressum.vue'
import Themes from '@/views/Themes.vue'
import HowItWorks from '@/views/HowItWorks.vue'
import Process from '@/views/Process.vue'
import Edit from '@/views/admin/Edit.vue'
import NewSurvey from '@/components/survey/NewSurvey.vue'
import List from '@/views/admin/List.vue'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import Verify from '@/views/Verify.vue'
import Results from '@/views/user/Results.vue'
import Analyse from '@/views/user/Analyse.vue'
import Groups from '@/views/user/Groups.vue'
import Collaboration from '@/views/user/Collaboration.vue'
import Collaborations from '@/views/user/Collaborations.vue'
import Schnelldelegation from '@/views/user/Schnelldelegation.vue'
import Teams from '@/views/user/Teams.vue'
import Group from '@/views/user/Group.vue'
import People from '@/views/user/People.vue'
import Contact from '@/views/Contact.vue'
import AssessmentSettings from '@/components/admin/forms/AssessmentSettings.vue'
import UserDashboard from '@/views/user/Dashboard.vue'
import Assessment from '@/views/user/Assessment.vue'
import AssessmentOverview from '@/views/AssessmentOverview.vue'
import restrictions from "@/router/restrictions.js"

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum
  },
  {
    path: '/themes',
    name: 'Themes',
    component: Themes
  },

  {
    path: '/account-set-up',
    name: 'Verify',
    component: Verify
  },
  {
    path: '/funktion',
    name: 'HowItWorks',
    component: HowItWorks
  },
  {
    path: '/hintergrund',
    name: 'About',
    component: About
  },
  {
    path: '/assessment',
    name: 'Assessment',
    component: Assessment,
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/assessment-overview',
    name: 'AssessmentOverview',
    component: AssessmentOverview,
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/results',
    name: 'Results',
    component: Results,
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/analyse',
    name: 'Analyse',
    component: Analyse,
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/assessment-settings',
    name: 'AssessmentSettings',
    component: AssessmentSettings,
    meta: {
      require_auth: true,
      role: "admin"
    }
  },
  {
    path: '/kontakt',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/vorteile',
    name: 'Process',
    component: Process
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard, 
    meta: {
      require_auth: true,
      role: "admin"
    }
  },
  {
    path: '/dashboard',
    name: 'UserDashboard',
    component: UserDashboard, 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/groups',
    name: 'Groups',
    component: Groups, 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/group/:id',
    name: 'ViewGroup',
    component: Group,
    props: (route) => ({
      title: "Edit Group",
      id: route.params.id,
    }), 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/collaborations',
    name: 'Collaborations',
    component: Collaborations, 
    meta: {
      require_auth: true,
      role: "user"
    }
  },  
  {
    path: '/schnelldelegation',
    name: 'Schnelldelegation',
    component: Schnelldelegation, 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/teams',
    name: 'Teams',
    component: Teams, 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/collaboration/:id',
    name: 'ViewCollaboration',
    component: Collaboration, 
    props: (route) => ({
      id: route.params.id,
    }), 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: '/people',
    name: 'People',
    component: People, 
    meta: {
      require_auth: true,
      role: "user"
    }
  },
  {
    path: "/users",
    name: "ListUsers", 
    component: List, 
    meta: {
      require_auth: true,
      role: "admin"
    },
    props: () => ({
      title: "List Users", 
      collection: "users", 
      list_item: "UserListItem"
    })
  },
  {
    path: '/users/:id',
    name: 'ViewUsers',
    component: Edit,
    props: (route) => ({
      title: "Edit User",
      id: route.params.id,
      collection: "users", 
      form: "UserForm", 
      other_panels: [
        "UserManagementButtons"
      ]
    }), 
    meta: {
      require_auth: true,
      role: "admin"
    }
  },
  {
    path: '/new-survey',
    name: 'NewSurvey',
    component: NewSurvey,
    meta: {
      require_auth: true,
      role: "admin"
    }
  },
  {
    path: '/surveys/:id',
    name: 'ViewSurveys',
    component: Edit,
    props: (route) => ({
      title: "Edit Survey",
      id: route.params.id,
      collection: "surveys", 
      form: "EditSurvey", 
    }), 
    meta: {
      require_auth: true,
      role: "admin"
    }
  },

  {
    path: "/surveys",
    name: "ListSurveys", 
    component: List, 
    meta: {
      require_auth: true,
      role: "admin"
    },
    props: () => ({
      title: "List Surveys", 
      collection: "surveys", 
      list_item: "SurveyListItem"
    })
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Edit,
    props: () => ({
      title: "Profile",
      collection: "users",
      id: restrictions.userId(),
      form: "UserForm", 
      other_panels: []
    }), 
    meta: {
      require_auth: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  from;
  if( !to.meta || !to.meta.require_auth ){
    // no restrictoins
    next();
  }
  else{  
    restrictions.checkAuth().then(( auth ) => {
      // requires log in
      if( auth.logged_in ){
        // requires role based secuirty
        if( to.meta.role ){
          restrictions.getUserRole().then( role => {
            if( role == to.meta.role ){
              // authed and right role 
              next();
            }
            else{
              // authed but wrong role -> redirect to home
              next("/")
            }
          });
        }
        else{
          // authed go to page
          next();
        }
      }
      else{
        // failed auth -> redirect to home
        next("/")
      }
    })
  }
})

export default router
